import type { SolverPhaseEmployeesModalProps } from "@/components/modals/SolverPhaseEmployeesModal.types.tsx";
import React, { useEffect } from "react";
import Modal from "./Modal";
import SolverPhaseEmployees, { buildSolverPhaseEmployeesController } from "@/components/sections/SolverPhaseEmployees.tsx";


/**
 * Main component
 * @param param0
 * @returns
 */
const SolverPhaseEmployeesModal: React.FC<SolverPhaseEmployeesModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        confirmDisabled = false,
        phase = {},
        phaseId,
        schedule
    }) => {

    const ctrl = buildSolverPhaseEmployeesController(phase, phaseId, schedule);

    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(() => {
        if (open) {
            ctrl.setEditData({ ...{}, ...phase });
        }
    }, [open]);

    const handleConfirm = () => {
        onConfirm(ctrl.editData);
        onClose();
    };

    const onEmployeeClick = (userId: string) => {
        const newMapOfEmployees: typeof ctrl.editData.mapOfEmployeeSettings = { ...{}, ...(ctrl.editData.mapOfEmployeeSettings || {}) };
        const curEmployee = newMapOfEmployees[userId] || { apply: false };

        if (curEmployee.apply !== true) {
            newMapOfEmployees[userId] = { apply: true };
        } else {
            delete newMapOfEmployees[userId];
        }

        ctrl.setEditData({
            ...ctrl.editData,
            ...{
                mapOfEmployeeSettings: newMapOfEmployees
            }
        })
    }

    const onAllEmployeesClick = () => {
        //@ Without any employee to reason about, clearing the map would silently drop a restriction the user cannot see.
        if (ctrl.viewData.listOfUIEmployees.length === 0) {
            return;
        }

        //@ "Tous" clears the map instead of listing everyone, so later hires stay included.
        ctrl.setEditData({
            ...ctrl.editData,
            ...{
                mapOfEmployeeSettings: {}
            }
        })
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            size="md"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={confirmDisabled}
                        className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${confirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                    >
                        {confirmLabel}
                    </button>
                </>
            }
        >
            <SolverPhaseEmployees
                onAllEmployeesClick={onAllEmployeesClick}
                onEmployeeClick={onEmployeeClick}
                controller={ctrl}>
            </SolverPhaseEmployees>

        </Modal>
    );
};

export default SolverPhaseEmployeesModal;
